import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ArrowLeft, Crown } from 'lucide-react';

const logo = '/assets/images/logo.png';

const HeaderEl = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255,255,255,0.88);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(45,188,175,0.1);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const BackBtn = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(45,188,175,0.12);
  color: #2DBCAF;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: rgba(45,188,175,0.22); }
  svg { width: 22px; height: 22px; }
`;

const LogoImg = styled.img`
  height: 42px;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CrownBtn = styled.button<{ $premium?: boolean }>`
  height: 40px;
  border-radius: ${p => p.$premium ? '50%' : '20px'};
  padding: ${p => p.$premium ? '0' : '0 14px 0 12px'};
  width: ${p => p.$premium ? '40px' : 'auto'};
  background: ${p => p.$premium 
    ? 'linear-gradient(135deg, #FFA929 0%, #FF8C00 100%)' 
    : 'linear-gradient(135deg, #FFA929 0%, #FF8C00 100%)'};
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(255, 169, 41, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Plus Jakarta Sans', sans-serif;
  
  &:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 12px rgba(255, 169, 41, 0.5);
  }
  
  svg { width: 18px; height: 18px; flex-shrink: 0; }
`;

interface AppHeaderProps {
  showBack?: boolean;
  showCrown?: boolean;
  isPremium?: boolean;
}

export default function AppHeader({ showBack = false, showCrown = false, isPremium = false }: AppHeaderProps) {
  const navigate = useNavigate();

  return (
    <HeaderEl>
      <Left>
        {showBack && (
          <BackBtn onClick={() => navigate(-1)}>
            <ArrowLeft />
          </BackBtn>
        )}
        <LogoImg src={logo} alt="Kindergame" />
      </Left>
      {showCrown && (
        <Right>
          <CrownBtn 
            $premium={isPremium} 
            title={isPremium ? "Premium Aktif" : "Aktivasi Premium"} 
            onClick={() => navigate('/premium')}
          >
            <Crown fill="currentColor" />
            {!isPremium && 'Aktivasi'}
          </CrownBtn>
        </Right>
      )}
    </HeaderEl>
  );
}
